import React from "react";
import { Routes, Route } from "react-router-dom";
import { Pages } from "components/pages";
import { RoutePermissionGuard } from "components/permissions";

const PermissionsRoute: React.FC = () =>
{
    return (
        <RoutePermissionGuard
            permissionSlug="permission_view_permissions"
            entryPoint="library"
            groupName="permission_group_permissions"
            action="permission_action_view"
        >
            <Routes>
                <Route path="/" element={<Pages.Permissions />} />
                <Route path="/page/:pageNum" element={<Pages.Permissions />} />
                <Route path="/page" element={<Pages.Permissions />} />
                <Route path="/:id/*" element={<Pages.Permission />} />
                <Route path="/create/*" element={<Pages.Permission />} />
            </Routes>
        </RoutePermissionGuard>
    );
};

export default PermissionsRoute;
